<!-- =========================================================================================
  File Name: AttendeeAdd.vue
  Description: Attendee Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-attendee-add" class="attendee-form-wrap">
    <div class="header-custome">
      <h3>Add Attendees</h3>
    </div>
    <vx-card v-if="attendee_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs position="left" v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Account" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <attendee-edit-tab-account :data="attendee_data" />
            </div>
          </vs-tab>
          
          
          <vs-tab disabled="true" label="Social" icon-pack="feather" icon="icon-share-2">
           <!-- <div class="tab-text">
              <attendee-edit-tab-social class="mt-4" :data="attendee_data" />
            </div>
            -->
          </vs-tab> 
          
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import attendeeEditTabAccount     from './AttendeeEditTabAccount.vue'
//import attendeeEditTabSocial      from './AttendeeEditTabSocial.vue'

// Store Module
import moduleattendeeManagementAdd from '@/store/attendee-management/moduleAttendeeManagement.js'

export default {
  components: {
    attendeeEditTabAccount,
    //attendeeEditTabInformation,
    //attendeeEditTabSocial
  },
  data () {
    return {
      attendee_data: null,
      attendee_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.fetch_attendee_data()
    }
  },
  methods: {
    fetch_attendee_data () {
      this.$store.dispatch('attendeeManagement/fetchAttendee', null)
        .then(res => { this.attendee_data = res.data })
        .catch(err => {          
          console.error(err) 
        })
    }
    
  },
  created () {
    // Register Module attendeeManagement Module
    if (!moduleattendeeManagementAdd.isRegistered) {
      this.$store.registerModule('attendeeManagement', moduleattendeeManagementAdd)
      moduleattendeeManagementAdd.isRegistered = true
    }    
    this.fetch_attendee_data()
  }
}

</script>